import { render, staticRenderFns } from "./vue-drag-resize.html?vue&type=template&id=7db81dde&"
import script from "./vue-drag-resize.js?vue&type=script&lang=js&"
export * from "./vue-drag-resize.js?vue&type=script&lang=js&"
import style0 from "./vue-drag-resize.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports